import React, { useCallback, useContext } from 'react'
import { RatingListStyles } from './Style'
import { ratingListLabel } from 'keys/rating'
import { Chip, Switch } from 'components/Form'
import { Divider } from '@mui/material'
import { thirdly2 } from 'styles/theme'
import { ProfilesContext } from './ProfilesContext'

const RatingList = () => {
    const { visibleRatings, setVisibleRatings } = useContext(ProfilesContext)

    const updateVisibleRatings = useCallback((ratingKey) => {
        setVisibleRatings(visibleRatings => ({
            ...visibleRatings,
            [ratingKey]: !visibleRatings[ratingKey]
        }))
    }, [])

    return (
        <RatingListStyles>
            <div className='rating-legend'>
                <div className='title'>
                    <i class="fa-light fa-tags"></i>
                    {"מקראת דירוגים"}
                </div>
                <Divider sx={{ borderColor: thirdly2 }} />
                <div className='rating-items'>
                    {ratingListLabel.map((rating, index) => {
                        const ratingKey = index + 1
                        return (
                            <div className='rating-item'>
                                <Chip color={`rating${ratingKey}`}>
                                    {rating}
                                </Chip>
                                <Switch
                                    input={{
                                        value: visibleRatings[ratingKey],
                                        onChange: () => updateVisibleRatings(ratingKey)
                                    }}

                                />
                            </div>)
                    })}
                </div>
            </div>
        </RatingListStyles >
    )
}

export default RatingList